import React from 'react';
import Accept from '../components/Apply/Accept';

export default function ApplyAccept() {
  return (
    <div>
      <Accept />
    </div>
  )
}